<template>
    <!--  <div style="margin-top:0px;" :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'">-->
    <div style="margin-top:0px;" :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'">
        <Header/>
        <div
            :class="$i18n.locale=='العربية'?'FrameWork__PageWrapper-v8gq48-13 eRmiUC':'FrameWork__PageWrapper-v8gq48-13 obiMX'" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important; '">
            <section class="style__SpotlightInnerWrap-sc-1qapdh8-0 kKgHVc">
                <div class="spotlight" :style="$i18n.locale == 'العربية' ?'float:right;width:100%;':'float:left;width:100%;'">
                    <div class="style__SpotlightItemStyled-vo40go-0 cDscbW">
                        <figure>
                            <div class=" gatsby-image-wrapper" style="position:relative;overflow:hidden">
                                <div aria-hidden="true" style="width:100%;padding-bottom:49.5%"></div>

                                <picture v-if="this.pagedata"><img
                                              :src="this.serverurl+'/public/pagebanners/'+pagedata.pagebanner"
                                              alt=""
                                              style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>

                                </picture>


                               <!--            <video style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"-->
<!--                   v-if="this.pagedata && this.pagedata.id==51"  width="100%"-->
<!--                   height="100%" autoplay loop>-->
<!--                <source :src="this.serverurl+'/public/pagebanners/scalping.webm'" type="video/webm" style="position:absolute;top:0;left:0;opacity:1;min-width:100%;min-height:100%;object-fit:cover;object-position:center" />-->
<!--                Your browser does not support the video tag.-->
<!--            </video>-->

                            </div>
                        </figure>
                        <div class="spotlight__info" :style="$i18n.locale == 'العربية' ?'float:right;width:100%;padding-left:8%;padding-right:8%':'float:left;margin-left:3%;width:100%;padding-left:8%;padding-right:8%'">
                            <div class="react-reveal"
                                 style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                <div class="style__SectionTitleStyled-d40vxv-0 kcvceY" :style="$i18n.locale == 'العربية' ?'float:right;margin-right:3%;width: 50%;':'float:left;margin-left:3%;width: 50%;'">
                                    <h2 v-if="pagedata" :style="$i18n.locale == 'العربية' ? 'text-align: right;font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'">
                                        {{
$i18n.locale == 'en' ? pagedata.page_entitle : $i18n.locale == 'العربية' ? pagedata.page_artitle : $i18n.locale == '中文' ? pagedata.page_chtitle :$i18n.locale=='Русский'?pagedata.page_rutitle: pagedata.page_frtitle
                                        }}</h2>
                                        <br />

<h3 v-if="pagedata" :style="$i18n.locale == 'العربية' ?'text-align: right;font-size: 23px!important;color:#ffffff;font-family: Cairo,sans-serif !important;margin-right:2%;':'font-size: 23px!important;color:#ffffff;font-family: Comfortaa!important;margin-left:2%'">
                                        {{
                                            $i18n.locale == 'en' ? pagedata.en_subtitle : $i18n.locale == 'العربية' ? pagedata.ar_subtitle : $i18n.locale == '中文' ? pagedata.ch_subtitle :$i18n.locale=='Русский'?pagedata.ru_subtitle: pagedata.fr_subtitle
                                        }}</h3>
                                </div>
                            </div>
                                                       <div class="btn_wrap" :style="$i18n.locale == 'العربية' ?'width:100%;float:right!important;margin-right:3%!important':'width:100%;float:left;margin-left:3%!important'">

                                <div class="react-reveal" :style="$i18n.locale == 'العربية' ?'float:right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg" style="width: 100%!important;text-align: center!important;"><a style=""
                                        href="https://marketequityinc.com/custom/demoaccountlinks.php" target="_blank"
                                        rel="noopener noreferrer"><span>
                                        {{
                                         $i18n.locale == 'en' ? 'Open Demo Account' : $i18n.locale == 'العربية' ? 'فتح حساب تجريبي' : $i18n.locale == '中文' ? '开设模拟账户':$i18n.locale=='Русский'?'Открыть демо-аккаунт' : 'Ouvrir un compte Dé'

                                        }}

                                        </span></a></div>
                                </div>
                                 <div class="react-reveal" :style="$i18n.locale == 'العربية' ?'float:right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg" style="width: 100%!important;text-align: center!important;"><a style=""
                                        href="https://marketequityinc.com/custom/liveaccountlinks.php" target="_blank"
                                        rel="noopener noreferrer"><span>
                                            {{
                                            $i18n.locale == 'en' ? 'Open Live Account' : $i18n.locale == 'العربية' ? 'فتح حساب حقيقي' : $i18n.locale == '中文' ? '开设真实账户':$i18n.locale=='Русский'?'Открыть реальный аккаунт': 'Ouvrir un compte Réel'
                                }}
                                        </span></a></div>
                                </div>
                                <div v-if="pagedata.layout==4" class="react-reveal"
                                     style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 360ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg"><a class="no-border"
                                                                                      href="https://www.linkedin.com/company/market-equity-inc/?originalSubdomain=in"
                                                                                      target="_blank"
                                                                                      rel="noopener noreferrer">
                                        <div class=" gatsby-image-wrapper"
                                             style="position: relative; overflow: hidden; display: inline-block; width: 100px; height: 30px;">
                                            <picture><img loading="lazy" width="100" height="30"
                                                          src="https://dev.marketequityinc.com/public/public/follow-linkedin.jpg"
                                                          alt="Follow us on Linked In"
                                                          style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                            </picture>
                                        </div>
                                    </a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalCenterTitle"></h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">

                                <form id="register">

                                    <div class="form-group row">
                                        <label for="staticEmail" class="col-sm-2 col-form-label">{{
                                                $i18n.locale == 'العربية' ?'عنوان البريد الالكترونى':'Email Address' }}</label>
                                        <div class="col-sm-10">
                                            <input type="text" class="form-control" id="inputemail" v-model="registeremail" placeholder="Email">

                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label for="inputPassword" class="col-sm-2 col-form-label">
                                          {{  $i18n.locale == 'العربية' ? 'كلمة السر':'Password' }}

                                            </label>
                                        <div class="col-sm-10">
                                            <input type="password" class="form-control" id="inputPassword" v-model="registerpassword" placeholder="Password">
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label for="inputmobile" class="col-sm-2 col-form-label">Mobile</label>
                                        <div class="col-sm-10">
                                            <input type="text" class="form-control" id="inputmobile" placeholder="Mobile" v-model="registermobile">
                                        </div>
                                    </div>


                                    <button  @click="showmore()" type="button" class="btn btn-primary" data-dismiss="modal">
                                        {{  $i18n.locale == 'العربية' ? 'سجل الأن':'Subscribe Now' }}
                                        </button>


                                </form>
                                <form id="signin" method="POST" style="display: none;" action="">

                                    <div class="form-group row">
                                        <label for="staticEmail" class="col-sm-2 col-form-label">{{
                                                $i18n.locale == 'العربية' ?'عنوان البريد الالكترونى':'Email Address' }}</label>
                                        <div class="col-sm-10">
                                            <input type="text" class="form-control" id="inputemailsignin" placeholder="Email" v-model="signinemail">

                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label for="inputPassword" class="col-sm-2 col-form-label">
                                            {{  $i18n.locale == 'العربية' ? 'كلمة السر':'Password' }}

                                        </label>                                        <div class="col-sm-10">
                                            <input type="password" class="form-control" id="inputPasswordsignin" placeholder="Password" v-model="signinpassword">
                                        </div>
                                    </div>




                                    <button  @click="showmoresignin()" type="button" class="btn btn-primary" data-dismiss="modal">Sign In</button>


                                </form>
                            </div>
                            <div class="modal-footer">
                                <p style="color:red" v-if="subscribeerror"> {{ subscribeerror }}</p>
<!--                                <button @click="showmore()"  type="button" class="btn btn-primary">Save changes</button>-->

                                <a style="font-weight: bold"  @click="showsignin()" type="button" >
                                    <label for="inputPassword" class="col-sm-2 col-form-label">{{$i18n.locale == 'العربية' ? 'تسجيل الدخول':'SignIn'}}</label>
                                     </a> |
                                <a style="font-weight: bold"  @click="showregister()" type="button"  >Register</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div  class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo">

                            <div class="FrameWork__ColSm-v8gq48-3 dIoETn">
                                <div class="react-reveal"
                                     style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">



                                        <div id="onerow" class="row" style="padding-top: 2%;
padding-bottom: 2%;padding-right: 2%;padding-left: 2%;">

                                            <div class="container">


                                                <!-- Modal -->
                                                <div  class="row">
                                                    <div style="padding: 0px 60px 10px 12px;"  class="col-sm-4">
                                                        <iframe :src="videodataonelink" class="embed-responsive-item" allow="autoplay; fullscreen" allowfullscreen=""   frameborder="0"></iframe>
                                                        <div style="background-color: rgb(10, 91, 110);color:#ffffff;padding-top:1%;padding-left:1%;padding-bottom:1%;" >
                                                            <h3>{{ videodataonename }}</h3>

                                                        </div>
                                                    </div>


                                                </div>



                                                <button :style="$i18n.locale == 'العربية'?'margin-right:4%;:0px;margin:0px;float:right;':'margin:0px;float:left'"  type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalCenter">
                                                    <h6 v-if="$i18n.locale == 'العربية'">
                                                        المزيد من الدروس سجل الأن</h6>
                                                    <h6 v-else-if="$i18n.locale == 'Français'">
                                                        Plus de leçons Abonnez-vous maintenant</h6>
                                                    <h6 v-else>More Lessons Subscribe Now</h6>
                                                </button>
                                                <p style="color:red" v-if="subscribeerror"> {{ subscribeerror }}</p>

                                            </div>

                                        </div>

                                </div>
                            </div>

                    <div class="FrameWork__ColSm-v8gq48-3 dIoETn" id="morevideos" style="display: none">
                        <div class="react-reveal"
                             style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">



                            <div class="row" style="padding-top: 2%;
padding-bottom: 2%;padding-right: 2%;padding-left: 2%;">

                                <div class="container">

                                    <!-- Modal -->
                                    <div  class="row">
                                        <div style="padding: 0px 60px 10px 12px;" v-for="videodatadetails in videodata" v-bind:key="videodatadetails.id" class="col-sm-4">
                                            <iframe :src="videodatadetails.videolink" class="embed-responsive-item" allow="autoplay; fullscreen" allowfullscreen=""   frameborder="0"></iframe>
                                            <div style="background-color: rgb(10, 91, 110);color:#ffffff;padding-top:1%;padding-left:1%;padding-bottom:1%;" >
                                                <h3>{{ videodatadetails.name }}</h3>

                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                        </div>




            </section>


            <iframe style="display: none; position: fixed; border: 0px none; overflow: hidden;"
                    src="https://marketequity.ladesk.com/scripts/generateWidget.php?v=5.21.17.15&amp;t=1607084151&amp;cwid=e00b30c6&amp;cwrt=C&amp;cwt=chat&amp;pt=Home%20page%20-%20Market%20Equity%20Inc%20-%20Leading%20Trading%20Service%20Provider&amp;ref=https%3A%2F%2Fmarketequity.com%2Fen%2F%23speciality"
                    allowfullscreen="true" allow="microphone; camera" tabindex="-1" class="i-embedded-chat"
                    id="icb_e00b30c6_305"></iframe>


            <Footer/>
        </div>

    </div>

</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
    name: 'page',
    data() {
        return {
            pagedata: '',

            pagenameroute: '',
            learningcoursesen:'',
             learningcoursesar:'',
            videodata:'',
            videodataonelink:'',
            videodataonename:'',
            exampleModalCenter : '',
            registeremail:'',
            registerpassword:'',
            registermobile:'',
            signinemail:'',
            signinpassword:'',
            subscribeerror:null


        }
    },
    components: {
        Header,
        Footer
    },
     mounted() {

        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', 'https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js')
        document.head.appendChild(recaptchaScript)
    },
    beforeMount() {
        this.exampleModalCenter =false;
        var pathvalues = (this.$route.path).split("/");

        if (pathvalues[1] == 'ar') {
            this.$i18n.locale = 'العربية';
        }
        if (pathvalues[1] == 'ch') {
            this.$i18n.locale = '中文';
        }
        if (pathvalues[1] == 'fr') {
            this.$i18n.locale = 'Français';
        }
        // this.$i18n.locale=pathvalues[1];
        this.pagenameroute=pathvalues[3];
        this.loadvideosdata(this.pagenameroute)
    },

    methods: {
        showsignin(){
            document.getElementById("signin").style.display = "block";
            document.getElementById("register").style.display = "none";

        },
        showregister(){
            document.getElementById("signin").style.display = "none";
            document.getElementById("register").style.display = "block";

        },
        showmore(){


            this.$axios.get("subscribenew", {
                params: {

                    email: this.registeremail,
                    password: this.registerpassword,
                    mobile: this.registermobile,
                    coursevideoid: this.pagenameroute,

                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)
                        if(res.data.code==200) {
                            document.getElementById("onerow").style.display = "none";
                            document.getElementById("morevideos").style.display = "block";
                        }
                    else{
                            this.exampleModalCenter=true;
                            this.showregister();
                        this.subscribeerror="Please Enter Valid Email/Password"
                        }


                    }
                });
        },
        showmoresignin(){



            this.$axios.get("subscribecheck", {
                params: {

                    email: this.signinemail,
                    password: this.signinpassword,
                                   }
            })
                .then(res => {
                    if (res) {
                        console.log(res)

                        if(res.data.code==200) {
                            document.getElementById("onerow").style.display = "none";
                            document.getElementById("morevideos").style.display = "block";
                        }
                        else{

                            this.showsignin()
                            this.subscribeerror="Please Enter Valid Email/Password"
                        }

                    }
                });
        },
        loadvideosdata(courseid) {
            this.$axios.get("loadcoursevideos", {
                params: {
                    courseid: courseid
                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)
                        this.pagedata = res.data.pagedata[0];
                        this.videodata = res.data.videodata;
                        this.videodataonelink=res.data.videodataone.videolink
                        this.videodataonename=res.data.videodataone.name

                    }
                });
        },

    }
}
</script>

<style>
th{
    background-color: #005060;
    color:#ffffff;
}
tbody tr:nth-child(even) {background-color: #f2f2f2;}
.carousel{
    background: #2f4357;
    margin-top: 20px;
}
.carousel-item{
    text-align: center;
    min-height: 280px; /* Prevent carousel from being distorted if for some reason image doesn't load */
}
.rtlclass {
    direction: rtl !important;


}

.ltrclass {
    direction: ltr !important;
}

select {
    width: 150px;
    line-height: 49px;
    height: 38px;
    font-size: 22px;
    outline: 0;
    margin-bottom: 15px;
}

.p {
    animation-fill-mode: both;
    animation-duration: 1000ms;
    animation-delay: 0ms;
    animation-iteration-count: 1;
    opacity: 1;
    animation-name: slideInUp;
}

#tabela th, td {
    padding: 30px;
}
tabela tr:nth-child(even) {background-color: #f2f2f2;}
a:hover,a:focus{
    text-decoration: none;
    outline: none;
}
#accordion .panel{
    border: none;
    border-radius: 3px;
    box-shadow: none;
    margin-bottom: 15px;
}
#accordion .panel-heading{
    padding: 0;
    border: none;
    border-radius: 3px;
}
#accordion .panel-title a{
    display: block;
    padding: 12px 15px 12px 50px;
    background: #ffffff;
    border: 1px solid #c3c3c3;
    border-radius: 3px;
    font-size: 22px;
    font-weight: bold;
    color: #005060;
    text-shadow: 1px 1px 1px #fff;
    position: relative;

}
#accordion .panel-title a:before{
    content: "-";
    font-family: "Font Awesome 5 Free";
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    background: #929191;
    font-size: 12px;
    font-weight: 900;
    color: #fdfbfb;
    text-align: center;
    box-shadow: inset 0 0 10px rgba(0,0,0,0.5);
    text-shadow: none;
    position: absolute;
    top: 8px;
    left: 15px;
}
#accordion .panel-title a.collapsed:before{ content: "+"; }
#accordion .panel-body{
    padding: 10px 15px;
    font-size: 15px;
    color: #222;
    line-height: 27px;
    border: none;
}
#accordion .panel-body p{ margin-bottom: 0; }
</style>

